<template lang="html">
  <div class="not-open">
    <img :src="$store.state.static_img_url+'mobile/pic/no.png'">
    <p class="one">非常抱歉~</p>
    <p class="two">当前页面暂不支持手机浏览器打开<br/>请访问电脑端网站查看</p>
    <!-- <p class="three" v-if="$route.name == 'MNotOpen'">{{link+'/'+$route.query.link}}</p> -->
    <div class="contact">
      <div class="left">
        <p class="p1">您的打开方式</p>
        <p class="p2">方式一：访问电脑端网站查看
          </br>&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp{{link}}
        </p>
        <p class="p2">方式二：访问“动脉橙”小程序查看</p>
      </div>
      <div class="right">
        <img :src="$store.state.static_img_url + 'pic/index/dmc-xcx.png'" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      link: this.$store.state.req_url
    }
  }
}
</script>

<style lang="stylus" scoped>
.not-open
  text-align: center;
  padding-top: 2.2rem;
  img
    width: 2rem;
    height: 2rem;
  .one
    font-size: .4rem;
    color: #333333;
    margin-top: .4rem
  .two
    font-size: .32rem;
    color: #999999;
    margin-top: .3rem;
    line-height: .44rem
  .three
    font-size: .28rem;
    color: rgba(250, 122, 80, 1);
    line-height: .44rem;
  .contact
    color: #ccc;
    font-size: .24rem;
    width: calc(100% - .8rem)
    position: fixed;
    bottom: .8rem;
    left: 20px;
    background-color: #F9F9F9
    text-align: left
    display: flex 
    justify-content space-between
    height: 2.4rem
    .left
      padding-top .4rem
      padding-left .3rem
      .p1
        color: #333
        font-size: .28rem
        margin-bottom: .3rem
      .p2
        color: #999
        font-size: .26rem
        &+.p2
          margin-top: .2rem
    .right
      padding .3rem
      img
        width: 1.8rem
        height: 1.8rem
</style>
